import { getPropertyTypeClass, getPropertyTypeText, isNotForSaleStatus, resolveListingPrice } from "utils/helpers";
import { PropertyMlsStatus } from "./PropertyCard/MLSStatus";



export const BasicPropertyDeatilsCard = ({ listing }: { listing: any }) => {
    const isTaxListing = listing.sale_type === 'Tax';
    const status = listing?.detail_items?.["Status"] || listing?.status_text;
    const typeClass = getPropertyTypeClass(listing?.type, status);
    const typeText = getPropertyTypeText(listing?.type, status);
    // Sold listings show what they sold for, not what they were listed at - and
    // only if this user is allowed to see the exact figure.
    const displayPrice = resolveListingPrice(listing?.sold_price_display, listing?.price);

    return (
        <div className="border border_radius--default p-4 font_size--medium">
            <div className="d-flex flex-row align-items-center flex-wrap">
                <h2 className="font_size--large_extra_extra color_carbon font-weight-bold m-0 mr-2">
                    {displayPrice.value}
                    {displayPrice.sqft && (
                        <span className="font_size--small font_weight--regular ml-1">{displayPrice.sqft}</span>
                    )}
                </h2>
                <div className="d-flex align-items-center">
                    {status !== "Sold" && (
                        <div className={`label label--${typeClass} mr-2 no-wrap`}>
                            {typeText}
                        </div>
                    )}
                    <PropertyMlsStatus mls_status_text={status} />
                </div>
            </div>
            <h1 className="font_weight--semi_bold font_size--medium d-inline-block pt-md-0 pt-2 mb-3 letter-spacing-normal">
                {listing?.street_address}, {listing?.city}, {listing?.zipcode}
            </h1>
            <div className="row no-gutters">
                <div className="col-md-9 col-12">
                    {isTaxListing ? (
                        <div className="row">
                            {listing?.bedrooms > 0 && (
                                <div className="col-md-4 col-6 pb-2">
                                    <span className="font_weight--bold">{listing.bedrooms}</span> Bedroom(s)
                                </div>
                            )}

                            {(listing?.full_bathrooms > 0 || listing?.half_bathrooms > 0) && (
                                <div className="col-md-4 col-6 pb-2">
                                    {listing?.full_bathrooms && (
                                        <span className="font_weight--bold">{listing.full_bathrooms} Full</span>
                                    )}
                                    {listing?.full_bathrooms && listing?.half_bathrooms && ' & '}
                                    {listing?.half_bathrooms && (
                                        <span className="font_weight--bold">{listing.half_bathrooms} Half</span>
                                    )}
                                    Bath(s)
                                </div>
                            )}

                            {listing?.sqft > 0 && (
                                <div className="col-md-4 col-6 pb-2">
                                    <span className="ftin">
                                        <span className="font_weight--bold">{listing.sqft}</span> Sqft.
                                    </span>
                                </div>
                            )}

                            {(listing?.price_per_sqft > 0 || listing?.soldprice_per_sqft > 0) && (
                                <div className="col-md-4 col-6 pb-2">
                                    <span className="ftin">
                                        <span className="font_weight--bold">{listing.price_per_sqft || listing?.soldprice_per_sqft}</span> Lot Sqft.
                                    </span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="row">
                            {listing.bedrooms && (
                                <div className="col-md-4 col-6 pb-2">
                                    <span className="font_weight--bold">{listing.bedrooms}</span> Bedroom(s)
                                    {listing.BedroomMax && listing.bedrooms < listing.BedroomMax && ` - ${listing.BedroomMax}`}
                                </div>
                            )}

                            {(listing?.full_bathrooms > 0 || listing?.half_bathrooms > 0) && (
                                <div className="col-md-4 col-6 pb-2">
                                    {listing?.full_bathrooms && (
                                        <span className="font_weight--bold">{listing.full_bathrooms} Full</span>
                                    )}
                                    {listing?.full_bathrooms && listing?.half_bathrooms && ' & '}
                                    {listing?.half_bathrooms && (
                                        <span className="font_weight--bold">{listing.half_bathrooms} Half</span>
                                    )}
                                    {" "}Bath(s)
                                </div>
                            )}

                            {listing?.detail_items["Building SQFT"] && (
                                <div className="col-md-4 col-6 pb-2">
                                    <span className="ftin">
                                        <span className="font_weight--bold">{listing?.detail_items["Building SQFT"]}</span> Sqft
                                    </span>
                                </div>
                            )}

                            {/* keys misisng in current api response  */}
                            {/* {listing.LotSize && listing.LotSize > 0 && (
                                <div className="col-md-4 col-6 pb-2">
                                    {listing.LotSizeUnit?.toUpperCase() === 'ACRE' ? (
                                        <span className="ftin">
                                            <span className="font_weight--bold">{new Intl.NumberFormat().format(listing.Acres)}</span> Lot Acres
                                        </span>
                                    ) : (
                                        <span className="ftin">
                                            <span className="font_weight--bold">{new Intl.NumberFormat().format(listing.LotSize)}</span> Lot Sqft
                                        </span>
                                    )}
                                </div>
                            )} */}

                            {listing?.detail_items["Property Type"] && (
                                <div className="col-md-4 col-6 pb-2">
                                    <div className="font_weight--bold">{listing?.detail_items["Property Type"]}</div>
                                </div>
                            )}

                            {(status === 'Active' || status === 'Terminated' || status === 'Expired') ? (
                                <div className="col-md-auto col-auto pb-2">
                                    <div className="cardv2--landscape__content__footer_dayson pt-0">
                                        <div className="circle_nimber" style={{ backgroundColor: 'rgba(1,131,97,0.24)' }}>
                                            {listing.dom} Day(s) on{' '}
                                            {listing.MLSOrgID === 1 ? 'Market' : 'HAR.com'}
                                        </div>
                                    </div>
                                </div>
                            ) : !isNotForSaleStatus(status) ? (
                                <div className="col-md-auto col-auto pb-2">
                                    <div className="cardv2--landscape__content__footer_dayson pt-0">
                                        <div className="circle_nimber" style={{ backgroundColor: 'rgba(1,131,97,0.24)' }}>
                                            {listing.dom === 0 ? 1 : listing.dom} Day(s) on{' '}
                                            {listing.MLSOrgID === 1 ? 'Market' : 'HAR.com'}
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {/* keys misisng in current api response  */}
                            {/* {listing.Property_Class_ID === 6 && listing.balcony_sqft && (
                                <div className="col-md-4 col-6 pb-2">
                                    <span className="ftin">
                                        <span className="font_weight--bold">
                                            {listing.balcony_sqft.Detail && !isNaN(listing.balcony_sqft.Detail)
                                                ? new Intl.NumberFormat().format(listing.balcony_sqft.Detail)
                                                : 'N/A'}
                                        </span> Balcony Sqft
                                    </span>
                                </div>
                            )} */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
